'use client';

import { c as _c } from "react/compiler-runtime";
import gsap from 'gsap';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useLayoutEffect, useRef } from 'react';
import { usePageTransition, useUser } from '@/lib/stores';
interface NavigationEventsWrapperProps {
  children?: React.ReactNode;
}
export function NavigationEventsWrapper(t0) {
  const $ = _c(25);
  const {
    children
  } = t0;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    isInitialLoad,
    setIsInitialLoad,
    hasHydrated,
    setHasHydrated
  } = usePageTransition();
  const {
    lastIntroPlayDate,
    setLastIntroPlayDate
  } = useUser();
  const overPageTransitionRef = useRef(null);
  const logoSvgRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== setHasHydrated) {
    t1 = () => {
      const unsubscribe = useUser.persist.onFinishHydration(() => {
        setHasHydrated(true);
      });
      useUser.persist.rehydrate();
      return unsubscribe;
    };
    t2 = [setHasHydrated];
    $[0] = setHasHydrated;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== hasHydrated || $[4] !== isInitialLoad || $[5] !== lastIntroPlayDate || $[6] !== pathname || $[7] !== setIsInitialLoad || $[8] !== setLastIntroPlayDate) {
    t3 = () => {
      if (!hasHydrated) {
        return;
      }
      const overPageTransition = overPageTransitionRef.current;
      if (!overPageTransition) {
        return;
      }
      const today = new Date().toDateString();
      const playFullIntro = pathname === "/" && isInitialLoad && lastIntroPlayDate !== today;
      const mediaQuery = window.matchMedia("(max-width: 800px)");
      const isMobile = mediaQuery.matches;
      document.documentElement.classList.add("no-scroll");
      if (playFullIntro) {
        if (!isMobile && logoSvgRef.current) {
          gsap.set(logoSvgRef.current, {
            opacity: 1
          });
          gsap.to(logoSvgRef.current, {
            y: -(window.innerHeight / 2) + 36,
            duration: 1.2,
            ease: "expo.inOut",
            delay: 0.5
          });
        }
        gsap.to(overPageTransition, {
          opacity: 0,
          duration: 0.6,
          ease: "power2.out",
          delay: isMobile ? 0.3 : 1.5,
          onStart: _temp,
          onComplete: () => {
            if (logoSvgRef.current) {
              gsap.set(logoSvgRef.current, {
                clearProps: "y",
                opacity: 0
              });
            }
            gsap.set(overPageTransition, {
              pointerEvents: "none"
            });
            setLastIntroPlayDate(today);
            setIsInitialLoad(false);
          }
        });
      } else {
        gsap.to(overPageTransition, {
          opacity: 0,
          duration: 0.3,
          ease: "power2.out",
          delay: 0.1,
          onStart: _temp2,
          onComplete: () => {
            gsap.set(overPageTransition, {
              pointerEvents: "none"
            });
            setIsInitialLoad(false);
          }
        });
      }
    };
    $[3] = hasHydrated;
    $[4] = isInitialLoad;
    $[5] = lastIntroPlayDate;
    $[6] = pathname;
    $[7] = setIsInitialLoad;
    $[8] = setLastIntroPlayDate;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== hasHydrated || $[11] !== isInitialLoad || $[12] !== lastIntroPlayDate || $[13] !== pathname || $[14] !== searchParams || $[15] !== setIsInitialLoad || $[16] !== setLastIntroPlayDate) {
    t4 = [pathname, searchParams, hasHydrated, isInitialLoad, lastIntroPlayDate, setLastIntroPlayDate, setIsInitialLoad];
    $[10] = hasHydrated;
    $[11] = isInitialLoad;
    $[12] = lastIntroPlayDate;
    $[13] = pathname;
    $[14] = searchParams;
    $[15] = setIsInitialLoad;
    $[16] = setLastIntroPlayDate;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  useLayoutEffect(t3, t4);
  let t5;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      opacity: 1,
      pointerEvents: "all"
    };
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== children || $[20] !== isInitialLoad || $[21] !== pathname) {
    t6 = pathname === "/" && isInitialLoad && <div ref={logoSvgRef} className="w-36 max-[800px]:hidden" style={{
      opacity: 0
    }}>{children}</div>;
    $[19] = children;
    $[20] = isInitialLoad;
    $[21] = pathname;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== t6) {
    t7 = <div ref={overPageTransitionRef} className="fixed top-0 left-0 z-9999 flex h-full w-full items-center justify-center bg-black text-christ-white-900" style={t5}>{t6}</div>;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
}
function _temp2() {
  document.documentElement.classList.remove("no-scroll");
}
function _temp() {
  document.documentElement.classList.remove("no-scroll");
}